var map = {
	"./deposit.png": 96318,
	"./events.png": 47073,
	"./eye.png": 43295,
	"./gameRecords.png": 16248,
	"./inbox.png": 21576,
	"./logout.png": 64684,
	"./profile.png": 15071,
	"./records.png": 73154,
	"./redeem.png": 34574,
	"./vip.png": 75977,
	"./withdraw.png": 96080
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15849;